var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: _vm.hasCurrentPackage
          ? "Đổi gói cho trường"
          : "Gán gói cho trường",
        width: "580px",
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "ps-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
      },
    },
    [
      _vm.schoolRow
        ? _c("div", { staticClass: "ps-school-context" }, [
            _c("div", { staticClass: "ps-school-avatar" }, [
              _c("i", { staticClass: "el-icon-school" }),
            ]),
            _c("div", [
              _c("strong", [_vm._v(_vm._s(_vm.schoolRow.school.name))]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.schoolRow.school.id) +
                    " · " +
                    _vm._s(
                      _vm._f("formatNumber")(_vm.schoolRow.currentStudents)
                    ) +
                    " học sinh đang học"
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "assignForm",
          staticClass: "ps-dialog-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Gói áp dụng", prop: "packageId" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "ps-full-width",
                  attrs: {
                    filterable: "",
                    placeholder: "Chọn gói đang sử dụng",
                  },
                  model: {
                    value: _vm.form.packageId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "packageId", $$v)
                    },
                    expression: "form.packageId",
                  },
                },
                _vm._l(_vm.packages, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.id,
                      attrs: {
                        label: `${item.code} · ${item.name}`,
                        value: item.id,
                      },
                    },
                    [
                      _c("div", { staticClass: "ps-option-row" }, [
                        _c("span", [
                          _c("b", [_vm._v(_vm._s(item.code))]),
                          _vm._v(" · " + _vm._s(item.name)),
                        ]),
                        _c("span", { staticClass: "ps-option-limit" }, [
                          _vm._v(
                            "Số lượng tối đa: " +
                              _vm._s(_vm._f("formatNumber")(item.limit))
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.selectedPackage
        ? _c("div", { staticClass: "ps-assignment-preview" }, [
            _c("div", { staticClass: "ps-preview-item" }, [
              _c("span", [_vm._v("Giới hạn cơ bản mới")]),
              _c("b", [
                _vm._v(
                  _vm._s(_vm._f("formatNumber")(_vm.selectedPackage.limit)) +
                    " học sinh"
                ),
              ]),
            ]),
            _c("div", { staticClass: "ps-preview-item" }, [
              _c("span", [_vm._v("Giới hạn hiệu lực sau khi gán")]),
              _c("b", [
                _vm._v(
                  _vm._s(_vm._f("formatNumber")(_vm.selectedPackage.limit)) +
                    " học sinh"
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.hasCurrentPackage &&
      _vm.form.packageId !== _vm.schoolRow.assignment.packageId
        ? _c("el-alert", {
            staticClass: "ps-dialog-alert",
            attrs: {
              type: "warning",
              closable: false,
              "show-icon": "",
              title:
                "Đổi gói sẽ tạo một lần áp dụng mới. Số lượng thêm của gói hiện tại không chuyển sang gói mới.",
            },
          })
        : _vm._e(),
      _vm.selectedPackage &&
      _vm.schoolRow &&
      _vm.schoolRow.currentStudents > _vm.selectedPackage.limit
        ? _c("el-alert", {
            staticClass: "ps-dialog-alert",
            attrs: {
              type: _vm.schoolRow.allowExceedStudentLimit ? "warning" : "error",
              closable: false,
              "show-icon": "",
              title: _vm.schoolRow.allowExceedStudentLimit
                ? "Số học sinh hiện tại đang lớn hơn giới hạn mới. Cấu hình cho phép trường tiếp tục thêm học sinh vượt giới hạn."
                : "Số học sinh hiện tại đang lớn hơn giới hạn mới. Các lượt thêm học sinh tiếp theo sẽ bị chặn cho đến khi số học sinh đang học không vượt quá giới hạn mới.",
            },
          })
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "ps-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visibleProxy = false
                },
              },
            },
            [_vm._v("Hủy")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.handleConfirm },
            },
            [
              _c("i", { staticClass: "el-icon-check" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.hasCurrentPackage
                      ? "Xác nhận đổi gói"
                      : "Xác nhận gán gói"
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }